import { gql } from '@apollo/client'

import { GTTripV2, GTTripV2SaleStatus, GTTripV2Status } from 'gql/types.generated'

const isOnTime = (trip: GTTripV2): boolean => {
  return trip.status === GTTripV2Status.OnTime
}

const isInTransit = (trip: GTTripV2): boolean => {
  return trip.status === GTTripV2Status.InTransit
}

const isCompleted = (trip: GTTripV2): boolean => {
  return trip.status === GTTripV2Status.Completed
}

export const canBeDeactivated = (trip: TSFixMe): TSFixMe => {
  return isOnTime(trip) || (isInTransit(trip) && trip.itinerary.length > 2)
}

export const canBeCancelled = (trip: TSFixMe): TSFixMe => {
  return isOnTime(trip) || isInTransit(trip) || isCompleted(trip)
}

export const resolvers = {
  Trip: {
    firstStop(trip: TSFixMe): TSFixMe {
      return trip.itinerary[0]
    },
    lastStop(trip: TSFixMe): TSFixMe {
      return trip.itinerary[trip.itinerary.length - 1]
    },
    intermediateStops(trip: TSFixMe): TSFixMe {
      return trip.itinerary.slice(1, trip.itinerary.length - 1)
    }
  },
  Mutation: {
    activateTripSale(_root: TSFixMe, { tripId }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'TripV2',
          id: tripId
        }),
        fragment: gql`
          fragment TripSaleStatus on TripV2 {
            saleStatus
          }
        `,
        data: {
          saleStatus: GTTripV2SaleStatus.Activated,
          __typename: 'TripV2'
        }
      })

      return null
    },
    deactivateTripSale(_root: TSFixMe, { tripId }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'TripV2',
          id: tripId
        }),
        fragment: gql`
          fragment TripSaleStatus on TripV2 {
            saleStatus
          }
        `,
        data: {
          saleStatus: GTTripV2SaleStatus.Deactivated,
          __typename: 'TripV2'
        }
      })

      return null
    },
    deactivateTrip(_root: TSFixMe, { tripId }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'TripV2',
          id: tripId
        }),
        fragment: gql`
          fragment TripStatusAndSaleStatus on TripV2 {
            status
            saleStatus
          }
        `,
        data: {
          status: GTTripV2Status.Cancelled,
          saleStatus: GTTripV2SaleStatus.Deactivated,
          __typename: 'TripV2'
        }
      })

      return null
    },
    changeTripVehicle(_root: TSFixMe, { tripId, vehicle }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'TripV2',
          id: tripId
        }),
        fragment: gql`
          fragment TripVehicle on TripV2 {
            vehicle {
              id
              name
              externalID
              schedule {
                type
              }
            }
          }
        `,
        data: {
          vehicle: {
            __typename: 'TripV2Vehicle',
            id: vehicle.id,
            name: vehicle.name,
            externalID: vehicle.externalID || null,
            schedule: {
              __typename: 'TripV2VehicleSchedule',
              type: vehicle.schedule.type
            }
          }
        }
      })

      return null
    },
    changeTripCrewUsers(_root: TSFixMe, { tripId, crewUsers }: TSFixMe, { cache }: TSFixMe): null {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'TripV2',
          id: tripId
        }),
        fragment: gql`
          fragment TripCrewUsers on TripV2 {
            crewUsers {
              id
              firstName
              lastName
              username
            }
          }
        `,
        data: {
          crewUsers: crewUsers.map((crewUser: TSFixMe): TSFixMe => {
            return {
              __typename: 'TripV2User',
              id: crewUser.id,
              firstName: crewUser.firstName,
              lastName: crewUser.lastName,
              username: crewUser.username
            }
          })
        }
      })

      return null
    }
  }
}
